import Modal from '@/components/Modal';
import styles from './index.module.less';
import { useMemo, useState, useEffect } from 'react';
import { message, Select } from 'antd';
import { useUserProvider } from '@/context/UserProvider';
import { useRouter } from 'next/router';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';
const Index = ({
  isModalOpen,
  handleCancel,
  sitesList,
}: {
  isModalOpen: boolean;
  handleCancel: () => void;
  sitesList: any[];
}) => {
  const router = useRouter();
  const howManySites = useMemo(() => {
    return sitesList.length;
  }, [sitesList]);

  const { onOpenLoginModal, isLogin } = useUserProvider();
  const handleConfirm = () => {
    ga_logEvent(EventName.click_upgrade_auto_removal);
    if (!isLogin) {
      onOpenLoginModal(true);
    } else {
      router.push('/setting');
    }
  };

  const hanleCopy = (url: string) => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        message.success('Content copied to clipboard');
      })
      .catch((err) => {
        message.error('Failed to copy content');
      });
  };
  const [selectData, setSelectData] = useState<any>({});
  useEffect(() => {
    if (sitesList.length > 0) {
      setSelectData(sitesList[0]);
    }
  }, [sitesList]);
  return (
    <Modal isModalOpen={isModalOpen} handleCancel={handleCancel}>
      <div className={styles.container}>
        <div className={styles.title}>Submit manual removal request</div>
        <div className={styles.main}>
          {howManySites == 1 && (
            <div className={styles.oneSite}>
              <div className={styles.first}>
                <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/blue-link.svg" alt="link" />
                <span>{selectData?.url}</span>
              </div>
              <div>DMCA Contact:</div>
              {selectData?.emails || selectData?.dmca_url ? (
                <div className={styles.have} onClick={() => hanleCopy(selectData?.emails || selectData?.dmca_url)}>
                  <div>{selectData?.emails || selectData?.dmca_url}</div>
                  <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/blue-copy.svg" alt="link" />
                </div>
              ) : (
                <div className={styles.nohave}>
                  No matching complaint email found for this domain. Please visit the website directly to find their
                  DMCA contact information.
                </div>
              )}
            </div>
          )}
          {howManySites > 1 && (
            <div className={styles.moreSites}>
              <div className={styles.selelct}>
                <img
                  src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/blue-link.svg"
                  className={styles.prefixIcon}
                />
                <Select
                  className={styles.select}
                  options={sitesList.map((item) => ({
                    label: item.url,
                    value: item.url,
                  }))}
                  value={selectData?.url}
                  onChange={(value) => {
                    setSelectData(sitesList.find((item) => item.url == value));
                  }}
                />
              </div>
              <div>DMCA Contact:</div>
              <div>
                {selectData?.emails || selectData?.dmca_url ? (
                  <div className={styles.have} onClick={() => hanleCopy(selectData?.emails || selectData?.dmca_url)}>
                    <div>{selectData?.emails || selectData?.dmca_url}</div>
                    <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/blue-copy.svg" alt="link" />
                  </div>
                ) : (
                  <div className={styles.nohave}>
                    No matching complaint email found for this domain. Please visit the website directly to find their
                    DMCA contact information.
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <div className={styles.explain}>
          <div>Example text:</div>
          <div>Subject: DMCA Takedown Request</div>
          <div>
            Dear [Recipient], I am [Your Name], the copyright owner of [Original Work]. The infringing content is
            located at:
          </div>
          <ul>{selectData?.links?.map((item: string) => <li key={item}>{item}</li>)}</ul>
          <div>Please remove or disable access to it.</div>
          <div
            onClick={() =>
              hanleCopy(
                `Dear [Recipient], I am [Your Name], the copyright owner of [Original Work]. The infringing content is located at:
${selectData?.links?.join('\n')}
Please remove or disable access to it.`,
              )
            }
          >
            <img src="https://res-front.pumpsoul.com/prod-erasa/image/dmca-takedown/blue-copy.svg" alt="link" />
            <span>Copy example text</span>
          </div>
        </div>
        <div className={styles.btns} onClick={handleConfirm}>
          🚀 Upgrade for automatic removals
        </div>
      </div>
    </Modal>
  );
};

export default Index;
